module.exports = __webpack_public_path__ + "media/images/photo/Commercial/slider1-7771f8cf8e380a0a1a12e578ccdd8a8c.png";